import { FirstMatchedTemplate, ProcessTemplate } from "./templates";

export const matchesSharedWithFilter = (share, sharedWithFilters = []) => {
        
        return sharedWithFilters.some((f) => {
            if (f.type === "sp") {
                return share.serviceProviderID === f.id;
            }
            if (f.type === "ben") {
                return share.beneficiaryID === f.id;
            }
            return false;
        });
    };


/* ---------------- Shared-with (free text) ---------------- */

export const matchesSharedWithText = ({
        share,
        serviceProvider,
        beneficiary,
        filters,
    }) => {
        if (!filters.sharedWithText) return true;

        const q = filters.sharedWithText.toLowerCase();

        const haystack = [
            serviceProvider,
            beneficiary,
            share?.tags?.SharedWithEmail?.Value,
        ]
            .filter(Boolean)
            .join(" ")
            .toLowerCase();

        return haystack.includes(q);
    };

/* ---------------- Normalize ---------------- */

export const normalizeShareFilters = (filters) => ({
        ...filters,
        sharedWith: Array.isArray(filters.sharedWith)
            ? filters.sharedWith
            : [],
    });


/* ---------------- Main matcher ---------------- */

export const matchesFilters = ({
        share,
        content,
        stream,
        address,
        filters,
        templates,
        serviceProvider,
        beneficiary,
    }) => {

        if (filters.sharedWith?.length > 0) {
            if (!matchesSharedWithFilter(share, filters.sharedWith)) {
                return false;
            }
        } else if (filters.sharedWithText) {
            if (
                !matchesSharedWithText({
                    share,
                    serviceProvider,
                    beneficiary,
                    filters,
                })
            ) {
                return false;
            }
        }

        if (filters.contentType) {
            if (filters.contentType === "Addresses") {
                if (!share.addressID || !address) return false;
            }
            else if (filters.contentType === "Documents") {
                if (!share.streamID || !stream) return false;
            }
            else {
                if (!share.securedcontentID || !content) return false;

                const matchedTemplate = FirstMatchedTemplate(content, templates);
                if (!matchedTemplate) return false;

                const typeTag = ProcessTemplate(matchedTemplate).contentTypeTag;
                const value = content.tags?.[typeTag]?.Value;

                if (value !== filters.contentType) {
                    return false;
                }
            }
        }
        
        if (filters.searchText) {
            const q = filters.searchText.toLowerCase();

            const matchedTemplate = FirstMatchedTemplate(content, templates);
            const titleTag = ProcessTemplate(matchedTemplate).contentNameTag;
            const contentTitle = content?.tags?.[titleTag]?.Value;



            const haystack = [
                contentTitle,
                stream?.tags?.Name?.Value,
                address?.tags?.atag?.Name,
                serviceProvider?.tags?.name?.Value,
                beneficiary?.tags?.name?.Value,
                share?.id,
                share?.addressID,
                share?.securedcontentID,
                share?.streamID,
                share?.serviceProviderID,
                share?.beneficiaryID,
            ]
                .filter(Boolean)
                .join(" ")
                .toLowerCase();

            if (!haystack.includes(q)) {
                return false;
            }
        }


        return true;
    };